export default {
  localStorageGet,
  localStorageSet,
  localStorageRemove,
  localStorageClear,
}

function localStorageSet(key, value) {
  localStorage.setItem(key, value)
}
function localStorageGet(key) {
  return localStorage.getItem(key)
}
function localStorageRemove(key) {
  localStorage.removeItem(key)
}
function localStorageClear() {
  localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/localStorageUtils.js